import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const AdminDetailsLoader = () => {
  return (
    <div>
      {/* <div className="border-b border-gray-300">
        <Skeleton height={20} width={150} />
      </div> */}
      <div className="my-5">
        <Skeleton height={10} width="100%" />
      </div>
      <div>
        {/* Assessment Type */}
        <div className="px-0 py-4 sm:grid sm:grid-cols-3 sm:gap-4 border-b border-gray-300">
          <Skeleton width={120} />
          <Skeleton height={20} width="100%" />
        </div>
        {/* Multi Sponsor */}
        <div className="px-0 py-4 sm:grid sm:grid-cols-3 sm:gap-4 border-b border-gray-300">
          <Skeleton width={120} />
          <Skeleton height={20} width="100%" />
        </div>
        {/* Additional Participating Sponsors */}
        <div className="px-0 py-4 sm:grid sm:grid-cols-3 sm:gap-4 border-b border-gray-300">
          <Skeleton width={200} />
          <Skeleton width="60%" />
        </div>
        {/* Location */}
        <div className="px-0 py-4 sm:grid sm:grid-cols-3 sm:gap-4 border-b border-gray-300">
          <Skeleton width={100} />
          <Skeleton height={40} width="100%" />
        </div>
      </div>
    </div>
  );
};

export default AdminDetailsLoader;
